module.exports = __webpack_public_path__ + "img/barrel.9bd3441c.png";